import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import "react-table/react-table.css";
import Calendar  from 'react-calendar';
import _ from 'lodash';
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link } from "react-router-dom";
import {connect} from 'react-redux';
import RequestForm from './RequestForm';


import '../styles/sideProfile.scss';
import '../styles/sellerDetail.scss';
import travellerIcon from '../img/traveller.jpg';


class SellerDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            showForm: false
        };

        this.getDetail = this.getDetail.bind(this);
        this.getDate = this.getDate.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
        this.getAcceptList = this.getAcceptList.bind(this);
    }

    componentDidMount() {
        this.getDetail();
    }

    getDetail(){
        let that = this; //this는 dashboardBuyer component!
        console.log(this); // not undefined
        // console.log("this.props", this.props);
        let payload = {
            "name": this.props.match.params.name,
        }
        axios.post('https://spice-api.pearlfall.vercel.app'+`/users/profile/seller`, payload)
            .then(function (response) {
                // console.log(this, that); //after function, it's undefined
                // console.log('response seller detail', response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    sellerId: response.data.user.sellerId,
                    username: response.data.user.username,
                    name: response.data.user.name,
                    region: response.data.user.region,
                    topic: response.data.user.topic,
                    description: response.data.user.description,
                }, ()=>{
                    // call after sellerId set on state
                    // console.log("is seller id set?", that.state.sellerId);
                    // setTimeout(()=> { that.getAcceptList();}, 1000);
                    that.getAcceptList();
                    // console.log("do you comeback here?");
                });
                // console.log("description", that.state.description);
            })
            .catch(function (error) {
                console.log(error);
            })
    }


    async getAcceptList(){
        let that = this;
        let payload = {
            "sellerId": this.state.sellerId,
        }
        await axios.post('https://spice-api.pearlfall.vercel.app'+`/requests/acceptedList`, payload)
            .then(function (response) {
                // console.log('response seller id', response);
                // console.log("All dates", _.map(response.data.request, 'date'));
                //there is one state ("occupiedDate") How can I set multiple occupied dates
                //into one state?
                that.setState({
                    // sellerId: response.data.request.sellerId,
                    occupiedDate: _.map(response.data.request, 'date')
                    //So Seller8 has 3 occupiedDates, but I don't know how to show all of them
                    //for now, I only made show one occupiedDate
                });
            })
            .catch(function (error) {
                console.log(error);
            });
        // console.log("you come here");
        const disabledDates = [new Date(that.state.occupiedDate)];
        // console.log("when is disable",disabledDates, that.state.occupiedDate);

    }

    getDate(date){
        this.setState({date});
        var selectedDate = date.toLocaleString().split(',').splice(0,1);
        this.setState({
            selectedDate: selectedDate
        })
        // console.log("what date", selectedDate);
    }

    // occupiedDate(){
    //
    // }

    toggleForm(){
        this.setState({
            showForm: !this.state.showForm
        })
    }

    render() {
        // if (this.state.occupiedDate){
        //     console.log("occupied date???", new Date(this.state.occupiedDate));
        //     let disabledDates = [new Date(this.state.occupiedDate)];
        // }

        const testDates = [
            new Date(2019, 10, 29),
            // because you set the month 10. Date's month field start from 0
            // So nov is 11 - 1 = 10

        ];
        const disabledDates = this.state.occupiedDate ?
            this.state.occupiedDate.map((item)=> new Date(item)) : [];
        // this one the trick, if no state.occupiedDate we just use empty array
        //Ahh so it makes calendar waits until disabledDates set on the state? >> Yes
        // console.log("disable dates", disabledDates);
        // console.log("test dates", testDates);
        // console.log("occupied date:", this.state.occupiedDate, this.state.occupiedDate !== undefined);

        return (
            // (this.state.occupiedDate) &&
            <div className="profile-right">

                <h1 className="text-center">
                    {this.state.description}!
                </h1>
                <div className="seller-detail">
                    <Row>
                        <Col xs="3">
                            <img src={travellerIcon} className="seller-img"/>
                                        <div style={{"margin-left": "20px"}}>
                                            Name: {this.state.name} <br />
                                            Username: {this.state.username} <br />
                                            Region: {this.state.region} <br />
                                            Talent: {this.state.topic} <br />
                                            Description: {this.state.description} <br />
                                            Total deals:
                                        </div>
                        </Col>
                        <Col xs="3">
                            <div className="about-me"> About Me </div>
                        </Col>

                        <Col xs="4">
                            {/*{this.state.occupiedDate &&*/}
                            <Calendar className="calendar" onChange={this.getDate} minDate={new Date()} value={this.state.date}
                                      tileDisabled={({date, view}) =>
                                          (view === 'month') &&// Block day tiles only
                                          disabledDates.some(disabledDate =>
                                              date.getFullYear() === disabledDate.getFullYear() &&
                                              // This one, compare date month field to another date month field
                                              // So no need to deduct one of them by 1
                                              date.getMonth() === (disabledDate.getMonth()) &&
                                              date.getDate() === disabledDate.getDate()
                                          )}

                            />
                            {/*}*/}
                        </Col>
                        <Col xs="2">
                            <button className="btn-request" onClick={this.toggleForm}>Request</button>
                            {this.state.showForm ?
                                <RequestForm closeForm={this.toggleForm}
                            sellerName = {this.state.username} selectedDate = {this.state.selectedDate}
                            topic = {this.state.topic} sellerId = {this.state.sellerId}
                            /> : null}
                            <Link className="btn-back" to ='/dashboard/buyer'>Back to List </Link>
                            {/*window.location (open new url and remove all info)-> Link */}
                        </Col>
                    </Row>
                </div>
                <div style = {{"font-size": "20px", "font-weight":"bold"}}> Review from other buyers...</div>

            </div>
        );
    }
}

function mapStateToProps(store) {
    return {};
}


export default withTracker(withRouter(connect(mapStateToProps)(SellerDetail)));
